import { createSlice, PayloadAction } from '@reduxjs/toolkit';


interface Transaction {
  availableBalance:number
  }
  interface TotalFundData {
    fundId: number;
    fundName: string;
    fundType:string;
    description: string;
    isActive:string;
    fundTransactionHistory:Transaction[]
  }
interface TransferFundState {
  
 
  funds:TotalFundData[]
  totalFunds:TotalFundData[]
  srcFundId:number | string | undefined 
  sourceAvailableBalance:number | string | undefined 
  targetFundId:number | string | undefined 
  transferAmount:number | string | undefined 
  targetAvailableBalance:number | string | undefined 
  comments:string
  fromFundName:string
  toFundName:string;
  checking:{
    fundId: number;
    fundName: string;
    availableBalance:number;
  };
}

  
const initialState: TransferFundState = {
  
  funds:[],
  totalFunds:[],
    srcFundId:"",
  sourceAvailableBalance:"",
  targetFundId:"",
  transferAmount:"",
  targetAvailableBalance:"",
  comments:"",
  fromFundName:"",
  toFundName:"",
  checking: {
    fundId: 0, 
    fundName: "", 
    availableBalance: 0,
  },
};

const transferFundsSlice = createSlice({
  name: 'TransferFunds',
  initialState,
  reducers: {
    setTransferFundsDetails: (state, action: PayloadAction<Partial<TransferFundState>>) => {
      return { ...state, ...action.payload };
    },
    resetTransferFunds: () => initialState,

  },
  
});

export const { setTransferFundsDetails,resetTransferFunds } = transferFundsSlice.actions;
export default transferFundsSlice.reducer;
